// extracted by mini-css-extract-plugin
export default {"input":"qnzJCN","wrapper":"I791bE","radio":"KFR69u","label":"QCwqB4"};